import { useField } from 'formik';
import { Form, Label, Select } from 'semantic-ui-react';

interface Props {
  placeholder: string;
  name: string;
  options: any;
  label?: string;
  clearable?: boolean;
  disabled?: boolean;
  value?: string;
  onChange?: any;
  touched?: boolean;
  mandatory?: boolean;
}

export default function MyNewSelectInput(props: Props) {
  const [field, meta, helpers] = useField(props.name);
  return (
    <Form.Field error={meta.touched && !!meta.error}>
      {props.mandatory ? (
        <>
          <label style={{ display: 'inline-block' }}>{props.label}</label>
          <span style={{ color: '#9f3a38' }}>*</span>
        </>
      ) : (
        <label>{props.label}</label>
      )}
      <Select
        disabled={props.disabled}
        // clearable
        options={props.options}
        value={field.value || null}
        onChange={(e, d) => helpers.setValue(d.value)}
        onBlur={() => helpers.setTouched(true)}
        placeholder={props.placeholder}
      />
      {(meta.touched || props.touched) && meta.error ? (
        <Label basic color="red" icon="warning sign">
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
}
